import { useRouter } from 'next/router';

import './ContentList.scss';
import icons from '../../shared/assets/icons/redesign';

const { ChevronRight } = icons;

export default function ContentList({
  useQuery,
  getListQuery,
  listName,
  ...props
}) {
  const router = useRouter();

  const { data = {} } = useQuery(getListQuery, {
    variables: { name: listName }
  });

  const list = data.getList?.items || props.list;

  if (!list) return;

  return (
    <ul className="_contentList">
      {list.map((item, idx) => {
        const [description, tip] = item.description
          ? item.description.split('> Tip:')
          : [];

        return (
          <li
            key={idx}
            className="_contentList-item cursor-pointer"
            onClick={() => item.content?.uri && router.push(item.content?.uri)}
          >
            <div className="_contentList-item-header">
              <h5 className="_contentList-item-header-title">
                <span>{idx + 1}.</span> {item.title}
              </h5>

              {item.content && (
                <span className="_contentList-item-link">
                  Bekijk{' '}
                  <ChevronRight className="_contentList-item-link-icon" />
                </span>
              )}
            </div>

            {item.imageUrl && (
              <img
                alt="content-image"
                className="_contentList-item-img"
                src={item.imageUrl}
              />
            )}

            <p className="_contentList-item-description">{description}</p>

            {tip && (
              <div className="_contentList-item-tip">
                <span>&#8226;</span>

                <p className="_contentList-item-tip-text">
                  <span className="bold">Tip:</span>
                  <br />
                  {tip}
                </p>
              </div>
            )}
          </li>
        );
      })}
    </ul>
  );
}
